import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import RequireAuth from "./Components/RequireAuth";
import { ToastProvider } from "./Components/Toast";
import OfflineGate from "./Components/OfflineGate";
import SessionExpiredPage from "./Components/States/SessionExpiredPage";
import HomePage from "./Pages/Homepage";
import LoginPage from "./Pages/LoginPage";
import CartPage from "./Pages/CartPage";
import DoctorListPage from "./Pages/DoctorListPage";
import MyBookings from "./Pages/MyBookings";
import UploadMedicalRecordPage from "./Pages/UploadMedicalRecordPage";
import WalletPage from "./Pages/WalletPage";
import MedicalRecordsPage from "./Pages/MedicalRecordsPage";
import ChatPage from "./Pages/ChatPage";
import FamilyPage from "./Pages/FamilyPage";
import AddressPage from "./Pages/AddressPage";
import HraPage from "./Pages/HraPage";
import HraQuestionsPage from "./Pages/HraQuestionsPage";
import NotificationsPage from "./Pages/NotificationsPage";
import DeleteAccountPage from "./Pages/DeleteAccountPage";
import HelpPage from "./Pages/HelpPage";
import DoctorBlogs from "./Pages/DoctorBlogs";
import PrivacyAndPolicy from "./Pages/PrivacyAndPolicy";
import TermsandConditions from "./Pages/TermsAndConditions";
import Hraresult from "./Pages/HraResult";
import QuestionPage from "./Pages/QuestionPage";
import MyProfile from "./Pages/MyProfile";
import ChangePassword from "./Pages/ChangePassword";
import ScheduleAppointmentPage from "./Pages/ScheduleAppointmentPage";
import ReviewConfirmPage from "./Pages/ReviewConfirmPage";
import BookingConfirmedPage from "./Pages/BookingConfirmedPage";
import LabTestsDiscoverPage from "./Pages/LabTestsDiscoverPage";
import LabTestsBookPage from "./Pages/LabTestsBookPage";
import LabTestsReviewPage from "./Pages/LabTestsReviewPage";
import LabTestsConfirmedPage from "./Pages/LabTestsConfirmedPage";
import PatientVideoCall from "./Pages/PatientVideoCall";

const guard = (element) => <RequireAuth>{element}</RequireAuth>;

function App() {
  return (
    <Router>
      <ToastProvider>
        <Helmet>
          <title>Elthium Health | Healthcare Solutions & Medical Services</title>
          <meta
            name="description"
            content="Credenthealth - Leading healthcare provider offering medical services, health solutions, patient care and innovative medical technology."
          />
          <meta name="keywords" content="credenthealth, healthcare, medical services, health solutions, patient care, medical technology" />
          <link rel="canonical" href="https://credenthealth.com" />
        </Helmet>

        <OfflineGate>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/session-expired" element={<SessionExpiredPage />} />
            <Route path="/home" element={guard(<HomePage />)} />
            <Route path="/cart" element={guard(<CartPage />)} />
            <Route path="/consultations" element={guard(<DoctorListPage />)} />
            <Route path="/consultations/video/:bookingId" element={<PatientVideoCall   />} />
            <Route path="/consultations/schedule" element={guard(<ScheduleAppointmentPage />)} />
            <Route path="/consultations/review" element={guard(<ReviewConfirmPage />)} />
            <Route path="/consultations/confirmed" element={guard(<BookingConfirmedPage />)} />
            <Route path="/doctor-category/:category/:type" element={<Navigate to="/consultations" replace />} />
            <Route path="/doctor-list/:categoryName" element={<Navigate to="/consultations" replace />} />
            <Route path="/mybookings" element={guard(<MyBookings />)} />
            <Route path="/lab-tests" element={guard(<LabTestsDiscoverPage />)} />
            <Route path="/lab-tests/book" element={guard(<LabTestsBookPage />)} />
            <Route path="/lab-tests/review" element={guard(<LabTestsReviewPage />)} />
            <Route path="/lab-tests/confirmed" element={guard(<LabTestsConfirmedPage />)} />
            <Route path="/lab-category" element={<Navigate to="/lab-tests" replace />} />
            <Route path="/labtest" element={<Navigate to="/lab-tests" replace />} />
            <Route path="/packages" element={<Navigate to="/lab-tests?tab=packages" replace />} />
            <Route path="/scan&xrays" element={<Navigate to="/lab-tests" replace />} />
            <Route path="/prescriptions" element={<Navigate to="/medicalrecord/upload" replace />} />
            <Route path="/medicalrecord/upload" element={guard(<UploadMedicalRecordPage />)} />
            <Route path="/diagnostics" element={<Navigate to="/lab-tests/book" replace state={{ fromCart: true }} />} />
            <Route path="/packagebooking" element={<Navigate to="/lab-tests/book" replace />} />
            <Route path="/wallet" element={guard(<WalletPage />)} />
            <Route path="/medicalrecord" element={guard(<MedicalRecordsPage />)} />
            <Route path="/chat" element={guard(<ChatPage />)} />
            <Route path="/family" element={guard(<FamilyPage />)} />
            <Route path="/address" element={guard(<AddressPage />)} />
            <Route path="/hra-category" element={guard(<HraPage />)} />
            <Route path="/hra-questions" element={guard(<HraQuestionsPage />)} />
            <Route path="/notification" element={guard(<NotificationsPage />)} />
            <Route path="/profile" element={<Navigate to="/myprofile" replace />} />
            <Route path="/myprofile" element={guard(<MyProfile />)} />
            <Route path="/delete-account" element={guard(<DeleteAccountPage />)} />
            <Route path="/help" element={guard(<HelpPage />)} />
            <Route path="/doctorblogs" element={guard(<DoctorBlogs />)} />
            <Route path="/privacyandpolicy" element={guard(<PrivacyAndPolicy />)} />
            <Route path="/termsandconditions" element={guard(<TermsandConditions />)} />
            <Route path="/hra-result" element={guard(<Hraresult />)} />
            <Route path="/questions" element={guard(<QuestionPage />)} />
            <Route path="/changepassword" element={guard(<ChangePassword />)} />
          </Routes>
        </OfflineGate>
      </ToastProvider>
    </Router>
  );
}

export default App;
